import { useMemo } from "react";

import { useConfiguration } from "./use-configuration";

export const useIsHeadless = () => {
  const isHeadless =
    useConfiguration<boolean>("is_headless_storefront")?.value === true;
  return useMemo(() => isHeadless, [isHeadless]);
};
